import React from "react";

const COLORS = {
    default: {
        base: "bg-transparent text-black",
        hover: "hover:bg-gray-200",
    },
    primary: {
        base: "bg-primary text-white",
        hover: "hover:bg-red-800",
    },
    secondary: {
        base: "bg-gray-500 text-white",
        hover: "hover:bg-gray-600",
    },
    success: {
        base: "bg-green-500 text-white",
        hover: "hover:bg-green-400",
    },
    error: {
        base: "bg-red-500 text-white",
        hover: "hover:bg-red-600",
    },
    info: {
        base: "bg-sky-500 text-white",
        hover: "hover:bg-sky-600",
    },
    warning: {
        base: "bg-yellow-500 text-black",
        hover: "hover:bg-yellow-400",
    },
    inherit: {
        base: "bg-transparent text-inherit",
        hover: "hover:bg-gray-200",
    },
};

const SIZES = {
    small: "p-1 text-sm", // dense padding
    medium: "p-2 text-base", // default
    large: "p-3 text-lg", // bigger padding
};

export default function CustomIconButton({
    children,
    size = "medium",
    color = "default",
    shape = "circle", // circle | square | rounded
    className,
    disabled = false,
    onClick,
    ...rest
}) {
    const colorClasses = COLORS[color] || COLORS.default;
    const sizeClasses = SIZES[size] || size; // if string, use directly
    const shapeClasses =
        shape === "square"
            ? "rounded-none"
            : shape === "rounded"
            ? "rounded-md"
            : shape === "rounded-sm"
            ? "rounded-sm"
            : "rounded-full";

    return (
        <button
            aria-label="hamburger-menu"
            type="button"
            disabled={disabled}
            onClick={onClick}
            className={`inline-flex bg-green items-center justify-center transition-colors duration-200 ${shapeClasses} ${sizeClasses} ${
                colorClasses.base
            } ${!disabled ? colorClasses.hover : ""} ${
                disabled ? "opacity-50 cursor-not-allowed" : ""
            } ${className}`}
            {...rest}
        >
            {children}
        </button>
    );
}
